import React, { PureComponent } from 'react'
import { Pane, Dialog, Heading } from 'evergreen-ui'
import { User } from '../../types';

import { Elements, StripeProvider } from 'react-stripe-elements'

import Payment from '../../components/Payment/Payment'
import Datafetcher from '../../utils/datafetcher';


interface Props {
    display: boolean
    user: User
    datafetcher: Datafetcher
    setDisplay: (a: boolean) => void
}

interface State {
    display: boolean
    user: User
}

export default class StripePaymentSaver extends PureComponent<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            display: this.props.display,
            user: this.props.user
        }
    }

    componentDidMount() {
        this.setState({
            display: this.props.display,
            user: this.props.user
        })
    }

    componentDidUpdate(oldProps: Props) {
        if (this.props === oldProps) { return }
        this.setState({
            display: this.props.display,
            user: this.props.user,
        })
    }

    render() {
        const { display, user } = this.state;
        const { datafetcher } = this.props;

        return (
            <Dialog
                isShown={display}
                onCloseComplete={() => { this.props.setDisplay(false) }}
                hasFooter={false}
                hasHeader={true}
            >
                <StripeProvider apiKey={process.env.REACT_STRIPE_PKEY || ""}>
                    <Pane padding={20} className="example">
                        <Heading marginBottom={0} size={800}>Payment information</Heading>
                        <Elements>
                            <Payment user={user} datafetcher={datafetcher} />
                        </Elements>
                    </Pane>
                </StripeProvider>
            </Dialog>
        )
    }

}